<template>
  <div class="woven-brand__logo" :class="classes">
    <a href="/dashboard"
    >
        <img src="@/assets/Woven_Logo.png" style="width: 120px" />
    </a>
  </div>
</template>
<script>
  export default {
    name: "Logo",
    props: {
      classes: String,
    },
  };
</script>